import { render, staticRenderFns } from "./cuerpo.vue?vue&type=template&id=6d6b2a0c&v-slot%3Aitem%5Bvalue.value%5D=props&"
import script from "./cuerpo.vue?vue&type=script&lang=js&"
export * from "./cuerpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports